module.exports = __webpack_public_path__ + "static/media/dw_square.d383d651.png";